import FileUpload from "components/FileUpload";
import CommonTextEditor from "components/common/CommonTextEditor";
import { useProjectFormContext } from "pages/project/context/ProjectFormContext";

const DESCRIPTION_TOOLBAR = {
  history: true,
  textStyle: true,
  headings: true,
  alignment: true,
  lists: true,
  insert: true,
  blocks: true,
  extras: true,
};

const PROJECT_MEDIA_ACCEPT = ".jpg,.jpeg,.png,.webp,.gif,.mp4,.webm,.ogg,.mov";

export default function StepProjectOverview() {
  const { values, setField, errors } = useProjectFormContext();

  return (
    <div className="space-y-6 transition-opacity duration-300">
      <fieldset className="min-w-0 border-0 p-0">
        <legend className="mb-2 block w-full px-0 text-xs font-semibold text-text-500">Description</legend>
        <div
          className={[
            "overflow-hidden rounded-xl border bg-white transition-shadow",
            errors.description ? "border-red-400 shadow-sm ring-1 ring-red-200" : "border-slate-200 shadow-card",
          ].join(" ")}
        >
          <div className="border-b border-slate-100 bg-accent-100/40 px-2 py-1.5">
            <p className="px-2 text-[10px] font-medium uppercase tracking-wide text-text-500">Formatting</p>
          </div>
          <CommonTextEditor
            value={values.description}
            onChange={(html) => setField("description", html)}
            placeholder="Describe the project's core mission, value proposition, and intended use of funds..."
            height={280}
            toolbarOptions={DESCRIPTION_TOOLBAR}
            error={errors.description}
          />
        </div>
      </fieldset>

      <div>
        {errors.imageUrl ? (
          <p className="mb-2 text-xs font-medium text-red-600" role="alert">
            {errors.imageUrl}
          </p>
        ) : null}
        <FileUpload
          title="Project images & video"
          accept={PROJECT_MEDIA_ACCEPT}
          multiple
          maxSizeMB={40}
          helperText="Multiple files allowed. Images (JPG, PNG, WebP, GIF) or video (MP4, WebM, MOV, OGG) — max 40 MB each."
          items={values.imageUrl}
          onItemsChange={(items) => setField("imageUrl", items)}
          showPreviewActions
          showPreviewProgress
        />
      </div>
    </div>
  );
}
